import React, { useState, useEffect } from "react";
import ParagraphTag from "../../reusebale/Paragraph";
import ImageTag from "../../reusebale/imageTag";
import db from "../../../db/index.json";
import { Plus } from "lucide-react";
import ReactPaginate from "react-paginate";
import BaseUrl from "../../../constants/BaseUrl";
import { useSelector } from "react-redux";
import moment from "moment";
import NoData from "../../reusebale/noData";

const BroadCastSection = ({ onViewDetails, onViewCreate, search }) => {
  const { broadcasts } = db;
  const { loginSuccess } = useSelector((state) => state.auth);

  const [page, setPage] = useState(0); // ReactPaginate uses 0-indexed pages
  const [limit] = useState(10);
  const [allData, setAllData] = useState([]);
  const [totalPages, setTotalPages] = useState(0);

  const GetBroadcastData = () => {
    const myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");
    myHeaders.append("Authorization", `Bearer ${loginSuccess?.token}`);

    const requestOptions = {
      method: "GET",
      headers: myHeaders,
      redirect: "follow",
    };

    fetch(
      `${BaseUrl}api/broadcast/getAllBroadcastsByLandlord?landlordId=${
        loginSuccess?.user?._id
      }&page=${page + 1}&limit=${limit}`,
      requestOptions
    )
      .then((response) => response.json())
      .then((result) => {
        if (result.success) {
          setAllData(result?.data || []);
          setTotalPages(result?.pagination?.totalPages || 0);
        }
      })
      .catch((error) => console.error(error));
  };

  useEffect(() => {
    if (loginSuccess?.token) {
      GetBroadcastData();
    }
  }, [page, loginSuccess]);

  const handlePageClick = (selectedPage) => {
    setPage(selectedPage.selected);
  };

  const filteredData = allData.filter((item) =>
    `${item?.title}`.toLowerCase().includes(search.toLowerCase())
  );

  return (
    <div className="h-full pt-4">
      <div className="bg-white w-full rounded-lg h-[87%]">
        <div className="w-[95%] mx-auto h-full">
          <div className="flex justify-between items-center h-[12%]">
            <div className="w-[70%]">
              <ParagraphTag
                content={broadcasts.heading}
                classes="text-darkColor font-popinsSemiBold text-lg"
              />
            </div>
            <div className="w-[30%] flex justify-end">
              <button
                className="w-[48%] bg-themeColor rounded-md flex items-center justify-center py-2"
                onClick={onViewCreate}
              >
                <Plus color="#FFFFFF" size={15} />
                <ParagraphTag
                  content="New Broadcasts"
                  classes="text-white font-popinsSemiBold text-xs pl-2"
                />
              </button>
            </div>
          </div>

          <div className="overflow-x-scroll w-full h-[88%] panelScroll pt-2">
            {filteredData.length === 0 ? (
              <NoData />
            ) : (
              filteredData.map((item, i) => (
                <div
                  key={item._id || i}
                  className="flex cursor-pointer py-2"
                  onClick={() => onViewDetails(item)}
                >
                  <div className="w-[80%] py-2 flex items-center">
                    <ImageTag
                      classes="w-[38px] h-[38px]"
                      path="/assets/daashboard/notification-color.png"
                      altText="logo"
                    />
                    <div className="px-2">
                      <ParagraphTag
                        content={item.title}
                        classes="text-darkColor font-popinsSemiBold text-xs"
                      />
                      <ParagraphTag
                        content={item.description}
                        classes="text-[#686868] font-popinsRegular text-[10px]"
                      />
                    </div>
                  </div>
                  <div className="w-[20%]">
                    <div className="px-4 py-4">
                      <ParagraphTag
                        content={moment(item.createdAt).format("MM/DD/YYYY")}
                        classes="text-darkColor font-popinsSemiBold text-xs"
                      />
                    </div>
                  </div>
                </div>
              ))
            )}
          </div>
        </div>
      </div>

      <div className="flex justify-center items-center h-[13%]">
        <ReactPaginate
          previousLabel="Previous"
          nextLabel="Next"
          breakLabel="..."
          pageCount={totalPages}
          marginPagesDisplayed={2}
          pageRangeDisplayed={3}
          onPageChange={handlePageClick}
          forcePage={page}
          containerClassName="flex space-x-2 items-center"
          pageClassName="px-3 py-1 border rounded-md text-sm font-popinsMedium cursor-pointer"
          previousClassName="px-3 py-1 border rounded-l-md text-sm cursor-pointer font-popinsMedium"
          nextClassName="px-3 py-1 border rounded-r-md text-sm font-popinsMedium cursor-pointer font-popinsMedium"
          disabledClassName="opacity-50 !cursor-not-allowed"
          activeClassName="bg-themeColor text-white"
          breakClassName="px-3 py-1 text-sm font-popinsMedium"
        />
      </div>
    </div>
  );
};

export default BroadCastSection;
